module.exports = __webpack_public_path__ + "starFalse.a33cabb7.png";